import Asistencia from '@components/mobile/PresenteeismTable/Asistencia';
import { TableCell } from '@mui/material';
import styles from '@styles/screens/mobile/PresenteeismTableControlBoard.module.css';
import React, { useEffect, useState } from 'react';
import { Loader } from '@shared/designSystem/Loader';

import { ReactComponent as BuildingSVG } from '@assets/SVGs/PresenteeismTable/BuildingSVG.svg';
import { ReactComponent as SearchSVG } from '@assets/SVGs/PresenteeismTable/SearchSVG.svg';

import Image from '@components/General/Image';
import { APIIntegration, apiConfig } from '@integrations/APIIntegration';
import { Navigate } from 'react-router-dom';

import { format, utcToZonedTime } from 'date-fns-tz';

import { usePopup } from '@contexts/popupContext';
import { Application } from '@core/Application';


function rowTemplate(_index, row) {

    const getColor = (color) => {
        switch(color) {
            case 'green':
                return '#56A725'
            case 'red':
                return '#FF5454'
            case 'yellow':
                return '#EEA821'
            default: 
                return '#6C778B'
        }
    }

    const processName = (name) => {
        const words = name.split(' ');
        const processedWords = words.map(word => {
            const firstLetter = word.charAt(0).toUpperCase();
            const restOfWord = word.slice(1).toLowerCase();
            return firstLetter + restOfWord;
        });
        return processedWords.join(' ');        
    }

    return (
        <React.Fragment>
            <TableCell component="th" scope="row" align='left'>
                <div className={styles['circle-mask']}  style={{width: '24px', height: '24px', marginRight: '10px', display: 'inline-block', verticalAlign: 'top'}}>
                    <Image src={row.photo || '/assets/Q.png'} alt="Profile Picture" isRound={true} style={{width: '100%', height: '100%'}}/>
                </div>
                <div style={{display: 'inline-block', maxWidth: 'calc(100% - 34px)', color: row.deactivated ? "gray" : '#101828', fontWeight: 'bold'}}>

                    {processName(row.colaborador)}
                </div>
            </TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.fecha}</TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.ingreso}</TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.egreso}</TableCell>
            <TableCell align="left" className={styles['table-row']}>
                <div style={{display: 'flex', paddingLeft: '20px', flexDirection: 'column'}}>

                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <circle cx="4" cy="4" r="3" fill={getColor(row.analisis.color)}/>
                        </svg>
                        <div className={styles['analisis-text']} style={{paddingLeft: '5px'}}>
                            {row.analisis.hsTrabajadasText}
                        </div>
                    </div>
                    <div style={{display: 'flex'}}>
                        <div style={{width: '8px', height: '8px', color: '#888693'}}>
                            {row.analisis.sign}
                        </div>
                        <div className={styles['shift-text']} style={{paddingLeft: '5px'}}>
                            {row.analisis.subtext}
                        </div>
                    </div>

                </div>
            </TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.edificio}</TableCell>
            <TableCell/>
        </React.Fragment>
    );
}


const processName = (name) => {
    const words = name.split(' ');
    const processedWords = words.map(word => {
        const firstLetter = word.charAt(0).toUpperCase();
        const restOfWord = word.slice(1).toLowerCase();
        return firstLetter + restOfWord;
    });
    return processedWords.join(' ');        
}

const renderBuildingItem = (colaborador) => (
    <>
        <div style={{width: '24px', height: '24px', marginRight: '10px', display: 'inline-block', verticalAlign: 'top'}}>
            <BuildingSVG/>
        </div>
        <div key={colaborador.id} style={{ display: 'inline-block', maxWidth: 'calc(100% - 34px)', color: '#101828' }}>
            {processName(colaborador.name)}
        </div>
    </>
);


const MobilePresenteeismTableControlBoard = ({org}) => {

    const [orgTimezone, setOrgTimezone] = useState(org.timezone ? org.timezone : 'America/Argentina/Buenos_Aires');

    const [open, setOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)

    const [loading, setLoading] = useState(false)
    const [response, setResponse] = useState([])
    const [searchField, setSearchField] = useState('')

    const [buildingsResponse, setBuildingResponse] = useState([])
    const [fetchingBuildings, setFetchingBuildings] = useState(false)

    const [date, setDate] = useState(new Date())
    const [dateRange, setDateRange] = useState(null)

    const { showPopup, hidePopup } = usePopup();

    useEffect(() => {
        console.log(org)
        if (org.timezone) {
            setOrgTimezone(org.timezone)
        }
        setDate(new Date())
        fetchBuildingsResponse()
    }, [org])

    useEffect(() => {
        if (date) {
            fetchPresenteeismResponse(false)
        } else {
            setResponse([])
        }
    }, [date])

    useEffect(() => {
        if (dateRange) {
            fetchPresenteeismResponse(true)
        } else {
            setResponse([])
        }
    }, [dateRange])


    const fetchPresenteeismResponse = async (isRange) => {
        setLoading(true)
        setResponse([])
        try {
            const dashboardService = Application.shared().coreDependencies.dashboardService;
            let result
            if (isRange){
                let startDate = dateRange[0].toLocaleDateString('en-ZA', {timezone: orgTimezone}).replace(/\//g, '-')
                let endDate = dateRange[1].toLocaleDateString('en-ZA', {timezone: orgTimezone}).replace(/\//g, '-')
                result = await dashboardService.getPresenteeismTableRange(org.id, startDate, endDate)
                
            } else {
                let processedDate = date.toLocaleDateString('en-ZA', {timeZone: orgTimezone}).replace(/\//g, '-')
                result = await dashboardService.getPresenteeismTableDay(org.id, processedDate)
            }

            let data = transformData(result)
            console.log(data)
            setResponse(data)
        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }

    function transformData(data) {
        let result = [];
        for (let buildingID in data.buildings) {
            for (let userID in data.buildings[buildingID].user_records) {
                let user = data.buildings[buildingID].user_records[userID];
                for (let recordID in data.buildings[buildingID].user_records[userID].records) {
                    let record = data.buildings[buildingID].user_records[userID].records[recordID];

                    let convertedRecord = transformRecord(record)
                    console.log(user)
                    result.push({
                        numeroWhatsapp: userID,
                        colaborador: user.name,
                        photo: user.imageURL,
                        ...convertedRecord,
                        edificio: data.buildings[buildingID].name,
                    });
                }
            }
        } 
        console.log(result)
        return result;
    }

    function transformRecord(record) {

        let dateCheckin = new Date(record.checkInTimestamp)

        let formattedDate = dateCheckin.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', timeZone: orgTimezone})
        
        let zonedDate = utcToZonedTime(dateCheckin, orgTimezone)
        let ingreso = format(zonedDate, 'HH:mm', { timeZone: orgTimezone });
        let egreso = 'N/A'

        let analisisText = "No se registró salida aún"
        let color = 'gray'

        if (record.checkOutTimestamp !== 0) {
            //Tiene check-out
            let dateCheckout = new Date(record.checkOutTimestamp)
            let zonedCheckout = utcToZonedTime(dateCheckout, orgTimezone)
            egreso = format(zonedCheckout, 'HH:mm', { timeZone: orgTimezone });

            analisisText = "Completo"
            color = 'green'
        } else {
            // No tiene check-out
            analisisText = "Pendiente"
            color = 'yellow'
        }


        return {
            fecha: formattedDate,
            ingreso: ingreso,
            egreso: egreso,
            analisis: {
                color: color,
                resultado: analisisText,
            },
        }

    }

    function minutesToHours(minutes) {
        // Round to the nearest whole number to avoid floating-point arithmetic issues
        const roundedMinutes = Math.round(minutes);
    
        // Calculate the number of hours and the remaining minutes
        const hours = Math.floor(roundedMinutes / 60);
        const remainingMinutes = roundedMinutes % 60;
    
        // Format the hours and minutes to ensure two digits
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = remainingMinutes.toString().padStart(2, '0');
    
        return `${formattedHours}:${formattedMinutes}`;
    }

    const fetchBuildingsResponse = async () => {
        const transformData = (data) => {
            let result = [];
            for (let building in data) {
                result.push({
                    name: data[building].name,
                    id: data[building].id,
                    qontactPoints: data[building].qontactPoints
                });
            }
            console.log(result)
            return result;
        }

        setFetchingBuildings(true)
        try {
            const dashboardService = Application.shared().coreDependencies.dashboardService;
            const result = await dashboardService.getBuildingsWithQps(org.id)

            setBuildingResponse(transformData(result))
        } catch (error) {
            console.error(error)
        }
        setFetchingBuildings(false)
    }

    return (
    <div className={styles['content-block']}>
        <div className={styles['header-container']}>
            Listado
        </div>
        <div className={styles['actions-container']}>
            <div className={styles['search-bar']}>
                <div className={styles['svg-container']}>
                    <SearchSVG/>
                </div>

                <div className={styles['search-field-container']}>
                    <input type='text' placeholder='Buscar...' className={styles['search-input']} onChange={e => {setSearchField(e.target.value)}}/>
                </div>
            </div>
            <div className={styles['building-picker-container']}>
            </div>
        </div>
        
        <div className={styles['icons-container']}>
            <div className={styles['name-container']}>
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="16" viewBox="0 0 33 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.3744 10.0393C9.11072 10.0393 12.7488 10.3475 12.7488 13.0133C12.7488 15.8214 8.50964 15.9899 6.69127 16L6.03108 16C4.09226 15.9899 0 15.8224 0 13.0301C0 10.2188 4.23915 10.0501 6.05752 10.04L6.27599 10.0394C6.31004 10.0393 6.34286 10.0393 6.3744 10.0393ZM6.3744 11.2988C4.04109 11.2988 1.25943 11.5985 1.25943 13.0301C1.25943 14.1652 2.98065 14.7412 6.3744 14.7412C9.76814 14.7412 11.4894 14.1594 11.4894 13.0133C11.4894 11.8756 9.76814 11.2988 6.3744 11.2988ZM14.0273 9.64715C16.2993 9.9872 16.7754 11.0392 16.7754 11.8612C16.7754 12.4733 16.5109 13.302 15.2489 13.7798C15.1759 13.8075 15.1003 13.8209 15.0256 13.8209C14.7712 13.8209 14.5319 13.6656 14.437 13.4145C14.3136 13.0896 14.4773 12.7252 14.8023 12.6026C15.5159 12.3323 15.5159 12.0023 15.5159 11.8612C15.5159 11.3852 14.9525 11.0594 13.8417 10.894C13.4975 10.8419 13.2599 10.5212 13.3111 10.1778C13.3631 9.83355 13.6898 9.60265 14.0273 9.64715ZM6.3744 0C8.75136 0 10.6859 1.93448 10.6859 4.31145C10.6909 5.45669 10.2467 6.53812 9.43733 7.35255C8.62962 8.16782 7.5507 8.6187 6.40294 8.6229H6.3744C3.99659 8.6229 2.06211 6.68841 2.06211 4.31145C2.06211 1.93448 3.99659 0 6.3744 0ZM12.3253 0.943565C13.9751 1.21392 15.1724 2.62532 15.1724 4.29869C15.1691 5.98213 13.9122 7.42795 12.248 7.66137C12.2187 7.66556 12.1893 7.66724 12.1599 7.66724C11.8509 7.66724 11.5814 7.43971 11.5369 7.12485C11.489 6.7806 11.7283 6.46155 12.0726 6.41369C13.1204 6.26676 13.9113 5.35745 13.913 4.29785C13.913 3.24496 13.159 2.35665 12.1221 2.18704C11.7787 2.12995 11.5461 1.80669 11.6024 1.46329C11.6586 1.11989 11.9836 0.88899 12.3253 0.943565ZM6.3744 1.25943C4.69096 1.25943 3.32154 2.62885 3.32154 4.31145C3.32154 5.99405 4.69096 7.36347 6.3744 7.36347H6.40042C7.20982 7.36011 7.97219 7.04189 8.54397 6.46508C9.1166 5.88994 9.42977 5.12504 9.42644 4.31397C9.42644 2.62885 8.05699 1.25943 6.3744 1.25943Z" fill="#344054"/>
                </svg>
            </div>
            <div className={styles['info-container']}>
                <div className={styles['times-container']}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2649 0C10.573 0 10.823 0.250045 10.823 0.558137L10.8234 1.18906C11.9099 1.26356 12.8124 1.63575 13.4511 2.27578C14.1484 2.97606 14.5153 3.98294 14.5116 5.19075V11.9799C14.5116 14.4595 12.9369 16 10.4029 16H4.10863C1.57469 16 0 14.438 0 11.9234V5.18926C0 2.85044 1.40431 1.34916 3.69463 1.18932L3.69509 0.558137C3.69509 0.250045 3.94514 0 4.25323 0C4.56132 0 4.81136 0.250045 4.81136 0.558137L4.81114 1.17506H9.70637L9.70675 0.558137C9.70675 0.250045 9.95679 0 10.2649 0ZM13.3953 6.6262H1.11627V11.9234C1.11627 13.8329 2.17897 14.8837 4.10863 14.8837H10.4029C12.3326 14.8837 13.3953 13.8523 13.3953 11.9799L13.3953 6.6262ZM9.70637 2.29134H4.81114L4.81136 3.00724C4.81136 3.31533 4.56132 3.56538 4.25323 3.56538C3.94514 3.56538 3.69509 3.31533 3.69509 3.00724L3.69469 2.30823C2.02755 2.44828 1.11627 3.45885 1.11627 5.18926V5.50993H13.3953L13.3953 5.18926C13.3983 4.27019 13.1512 3.55578 12.6608 3.06462C12.2303 2.63285 11.601 2.37499 10.8237 2.30859L10.823 3.00724C10.823 3.31533 10.573 3.56538 10.2649 3.56538C9.95679 3.56538 9.70675 3.31533 9.70675 3.00724L9.70637 2.29134Z" fill="#344054"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                        <path d="M5.44444 2.12747H2.77778C2.30628 2.12747 1.8541 2.30849 1.5207 2.6307C1.1873 2.95291 1 3.38993 1 3.8456V4.70467M5.44444 15.8725H2.77778C2.30628 15.8725 1.8541 15.6915 1.5207 15.3693C1.1873 15.0471 1 14.6101 1 14.1544V13.2953M11.6658 9H11.6667M1 9H5.44444M5.44444 9L3.66667 7.28187M5.44444 9L3.66667 10.7181M15.7333 15.3811L10.4 16.9275C10.1345 17.0045 9.85405 17.0204 9.58104 16.974C9.30803 16.9277 9.05003 16.8202 8.82764 16.6603C8.60525 16.5004 8.42463 16.2924 8.30022 16.053C8.17581 15.8136 8.11105 15.5494 8.11111 15.2815V2.71851C8.11105 2.45061 8.17581 2.18641 8.30022 1.94701C8.42463 1.70761 8.60525 1.49964 8.82764 1.33972C9.05003 1.17979 9.30803 1.07235 9.58104 1.02596C9.85405 0.979566 10.1345 0.995518 10.4 1.07254L15.7333 2.61886C16.0995 2.72509 16.4205 2.9426 16.6487 3.23911C16.8769 3.53561 17.0001 3.89531 17 4.26483V13.7352C17.0001 14.1047 16.8769 14.4644 16.6487 14.7609C16.4205 15.0574 16.0995 15.2749 15.7333 15.3811Z" stroke="#344054" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                        <path d="M12.5556 2.12747H15.2222C15.6937 2.12747 16.1459 2.30849 16.4793 2.6307C16.8127 2.95291 17 3.38993 17 3.8456V4.70467M12.5556 15.8725H15.2222C15.6937 15.8725 16.1459 15.6915 16.4793 15.3693C16.8127 15.0471 17 14.6101 17 14.1544V13.2953M6.33422 9H6.33333M2.26667 15.3811L7.6 16.9275C7.8655 17.0045 8.14595 17.0204 8.41896 16.974C8.69197 16.9277 8.94998 16.8202 9.17237 16.6603C9.39476 16.5004 9.57537 16.2924 9.69978 16.053C9.82419 15.8136 9.88895 15.5494 9.88889 15.2815V2.71851C9.88895 2.45061 9.82419 2.18641 9.69978 1.94701C9.57537 1.70761 9.39476 1.49964 9.17237 1.33972C8.94998 1.17979 8.69197 1.07235 8.41896 1.02596C8.14595 0.979566 7.8655 0.995518 7.6 1.07254L2.26667 2.61886C1.90046 2.72509 1.57946 2.9426 1.35128 3.23911C1.1231 3.53561 0.999916 3.89531 1 4.26483V13.7352C0.999916 14.1047 1.1231 14.4644 1.35128 14.7609C1.57946 15.0574 1.90046 15.2749 2.26667 15.3811Z" stroke="#344054" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M31.4168 12.2227C31.0218 12.6437 30.3532 12.6437 29.9582 12.2227L27.3421 9.43421C26.743 8.79564 27.1958 7.75 28.0714 7.75L33.3036 7.75C34.1792 7.75 34.632 8.79564 34.0329 9.43421L31.4168 12.2227Z" fill="#9FA8B8"/>
                        <path d="M16.3334 8.99938H20.7778M20.7778 8.99938L19.0001 7.28125M20.7778 8.99938L19.0001 10.7175" stroke="#344054" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>           
            </div>
            <div className={styles['status-container']}>
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="19" viewBox="0 0 36 19" fill="none">
                    <path d="M15.9538 7.09135V6.9375C15.9538 4.72836 14.163 2.9375 11.9538 2.9375H5C2.79086 2.9375 1 4.72836 1 6.9375V11.676C1 13.8851 2.79086 15.676 5 15.676H8.47692" stroke="#344054" stroke-width="1.2" stroke-linecap="round"/>
                    <path d="M5.15381 1V2.93846" stroke="#344054" stroke-width="1.2" stroke-linecap="round"/>
                    <path d="M9.30762 7.37109H4.323" stroke="#344054" stroke-width="1.2" stroke-linecap="round"/>
                    <path d="M7.09229 11.2461H4.32305" stroke="#344054" stroke-width="1.2" stroke-linecap="round"/>
                    <path d="M12.0771 1V2.93846" stroke="#344054" stroke-width="1.2" stroke-linecap="round"/>
                    <path d="M15.4001 18.0036C17.6033 18.0036 19.3878 16.2191 19.3878 14.0159C19.3878 11.8127 17.6033 10.0282 15.4001 10.0282C13.1969 10.0282 11.4125 11.8127 11.4125 14.0159C11.4125 16.2191 13.1969 18.0036 15.4001 18.0036ZM15.4001 9.03125C18.1417 9.03125 20.3848 11.2743 20.3848 14.0159C20.3848 16.7574 18.1417 19.0005 15.4001 19.0005C12.6437 19.0005 10.4155 16.7574 10.4155 14.0159C10.4155 11.2743 12.6586 9.03125 15.4001 9.03125ZM15.6494 14.5143H14.9017V11.5236H15.6494V13.647L17.4937 12.5853L17.8675 13.2333L15.6494 14.5143Z" fill="#344054"/>
                </svg>
            </div>
        </div>
x
        {loading ?
            <div className={styles['loading-container']}>
                <Loader height="48px" width="48px" />
            </div>
            :
            response
            .filter(userRow => {return userRow.colaborador.toLowerCase().replace(/\s/g, '').includes(searchField.toLowerCase().replace(/\s/g, ''))})
            .map((row, index) => {
              
                return (
                    <Asistencia 
                        key={index}
                        colaborador={row.colaborador}
                        fecha={row.fecha.substring(0, 5)}
                        entrada={row.ingreso}
                        salida={row.egreso}
                        edificio={row.edificio}
                        estado={row.analisis.color}
                    />
                )
            })
        }
    </div>
    );
};

const MobilePresenteeismTableControlBoardWrapper = ({org}) => {
    if (!org.flags.hasPresenteeismTable) {
        return <Navigate to="/" />;
    }

    return <MobilePresenteeismTableControlBoard org={org}/>
}

export default MobilePresenteeismTableControlBoardWrapper
